import { Area, AreaChart, CartesianGrid, ReferenceLine, ResponsiveContainer, Tooltip, XAxis, YAxis } from "recharts";

interface Props {
  prices: number[]; // sorted descending, length = 8760
}

export function PriceDurationCurveChart({ prices }: Props) {
  // Down-sample voor performance — toon 1 punt per ~10 uur (876 punten)
  const step = Math.max(1, Math.floor(prices.length / 876));
  const data = prices
    .filter((_, i) => i % step === 0)
    .map((price, i) => ({
      uur: i * step,
      prijs: Math.round(price * 1000) / 1000,
    }));

  const negativeCount = prices.filter((p) => p < 0).length;
  const negativePct = (negativeCount / prices.length) * 100;

  return (
    <div>
      <div className="flex justify-between items-baseline flex-wrap gap-2 mb-1">
        <div className="serif text-lg font-medium">Prijsduurcurve 2025 NL</div>
        <span className="help mono">
          {negativeCount} uur ({negativePct.toFixed(1)}%) onder €0
        </span>
      </div>
      <div className="help mb-3">
        Uurprijzen 2025 gesorteerd van duur naar goedkoop. Bron: energy‑charts.info (Fraunhofer ISE), CC BY 4.0.
      </div>
      <ResponsiveContainer width="100%" height={220}>
        <AreaChart data={data} margin={{ left: 5, right: 10, top: 5, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#E5DFD3" />
          <XAxis dataKey="uur" tick={{ fill: "#6B6661", fontSize: 11 }} label={{ value: "uur (gesorteerd)", position: "insideBottom", offset: -5, fill: "#6B6661", fontSize: 11 }} />
          <YAxis tick={{ fill: "#6B6661", fontSize: 11 }} tickFormatter={(v) => `€${v.toFixed(2)}`} />
          <Tooltip
            formatter={(v: number) => `€${v.toFixed(3)}/kWh`}
            labelFormatter={(l) => `Uur ${l}`}
            contentStyle={{ background: "#FFFFFF", border: "1px solid #C9C0B0", borderRadius: 8 }}
          />
          <ReferenceLine y={0} stroke="#8B3A1F" strokeDasharray="3 3" />
          <Area type="monotone" dataKey="prijs" stroke="#2C4A3E" fill="#E8EFE9" strokeWidth={1.5} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
